import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../../providers/auth.service';
import { SharedJobService } from '../../shared/services/shared-job.service';
import { PublicJobService } from '../../../../public/services/public-job.service';
import { SharedHackService } from '../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../screen-talent.service';

declare var $: any;


export class TestFormComponent implements OnInit {

	public test: any = {
		roles: [],
		type: 'online-test'
	};
	public jobTitles: any;

	constructor(
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private sharedJobService: SharedJobService,
		private publicJobService: PublicJobService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.getJobTitles();
	}

	// Events
	public onTestFormSubmit(): void {
		if (this.test.type === 'remote-interview') {
			this.test.time = 1440;
		}
		this.sharedHackService.postExternalTest(String(this.authService.userId), this.test).subscribe(
			(test) => {
				this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'testCreated', data: test });
			},
			(err) => {
				this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'testCreated', data: false });
			}
		);
	}

	public onChosenChange(changes: any): void {
		if (changes && typeof changes.default !== 'undefined') {
			this.test.roles = changes.default;
		}
	}

	// Service Call
	private getJobTitles(): void {
		this.publicJobService.getJobTitles().subscribe(
			(jobTitles) => {
				this.jobTitles = jobTitles;
			}
		);
	}

	// Helpers
static ctorParameters() { return [ { type: AuthService }, { type: SharedHackService }, { type: SharedJobService }, { type: PublicJobService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test-form/test-form.component.ts